<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../../../../_shared/_logic/rich-tooltips"
  import { buildCancelReplanWorkOrderTag } from "../../../../../../../../_logic/cancel-replan-presentation"

  let {
    workOrder = null,
  }: {
    workOrder?: WorkOrder | null
  } = $props()

  const tag = $derived(buildCancelReplanWorkOrderTag(workOrder))
</script>

<StatusTag
  variant="neutral"
  size="sm"
  label={tag.label}
  subLabel={tag.subLabel ?? undefined}
  iconText={tag.numberLabel}
  color={tag.color}
  tooltipContent={tag.tooltip}
  tooltipHtml={true}
  tooltipClassName={RICH_TOOLTIP_CLASS}
  disableTitle={true}
/>
